<template>
  <div>
    <item
      v-for="item in data.PollFormData"
      :key="item.id"
      :data="item"
      :updateKey="data.UpdateKey"
      :onUpdateData="handleUpdateData"
    />
    <div style="padding: 20px;">
    <v-btn
      @click="handleSendPoll"
      block
      :color="btnBackgroundColor"
    >
      <span :style="{ 'color' : btnTextColor }">
        {{ $t('common.send') }}
      </span>
    </v-btn>
    </div>
    <v-snackbar
      v-model="snackbar"
      color="success"
    >
      {{ $t('poll.messages.sendDataSuccess') }}
 
      <template >
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          {{$t('common.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import axios from 'axios'
  import utils from '@/services/utils'
  import Item from './Item'
  export default {
    components: {
      Item
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data () {
      return {
        body: [],
        snackbar: false
      }
    },
    computed: {
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },
    },
    methods: {
      handleUpdateData (id, value) {
        if (this.body.filter(x => x.id === id).length > 0) {
          this.body.filter(x => x.id === id)[0].value = value
        } else {
          this.body.push ({
            id,
            value
          })
        }
      },
      handleSendPoll () {
        console.log(this.data)
        axios.post(utils.getAPIURL('contents', false, this.data.ID.concat('/poll')), this.body)
          .then(response => {
            console.log(response)
            this.snackbar = true
          })
          .catch(error => {
            console.log('error', error)
          })
      }
    }
  }
</script>
